module.exports = "<div id=\"router-wrap\">\r\n    <router-outlet></router-outlet>\r\n\r\n</div>\r\n<footer>\r\n\r\n    <div class=\"col-md-4 col-sm-4\">\r\n        <a href=\"https://www.prophoenix.com/\" class=\"footertag\"><p class=\"text-center\">&copy; 2026 ProPhoenix Corporation</p></a>\r\n    </div>\r\n\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// ./SignClient/app/app.component.html
// module id = ./SignClient/app/app.component.html
// module chunks = main